export const generateHashCode = function (str: string) {
  let hash = 0;
  if (str.length === 0) return hash;
  for (let i = 0; i < str.length; i++) {
    const chr = str.charCodeAt(i);
    hash = (hash << 5) - hash + chr;
    hash |= 0;
  }
  return hash;
};

export const isTimestampInSample = function (timestamp: string | number, sampleRate: number) {
  const hashNumber = generateHashCode(timestamp.toString());
  const absHash = Math.abs(hashNumber);
  const absHashMultiply = absHash * 31;
  const mod = absHashMultiply % 1000000;
  return mod / 1000000 < sampleRate;
};

// TODO(xinyi): replace the temp one in diagnostics client after the fix
// istanbul ignore next
export const isTimestampInSampleTemp = function (timestamp: string | number, sampleRate: number) {
  const hashNumber = generateHashCode(timestamp.toString());
  const absHash = Math.abs(hashNumber);
  const absHashMultiply = absHash * 31;
  const mod = absHashMultiply % 100000;
  return mod / 100000 < sampleRate;
};
